<template>
  <div v-show="searchStatus" class="search-wrapper">
    <el-select
      v-model="tableParams.activeStatus"
      clearable
      placeholder="活动状态">
      <el-option
        v-for="item in activityOptions"
        :key="item.activityId"
        :label="item.title"
        :value="item.activityId"/>
    </el-select>

    <el-button @click="toQuery" type="primary" >搜索</el-button>

    <div class="table-wrapper">
      <el-table
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        ref="report"
        row-key="id"
        lazy
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in commodityColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          sortable
          :min-width="v.minWidth"
          :key="i"
          align="center">
          <template v-slot="scope">
            <template v-if="v.field === 'authorPic'">
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                ref="popover"
              >
                <template #reference>
                  <el-image
                    :src="scope.row[v.field]"
                    error="-"
                    width="100"
                  >
                    <template #error>
                      <div class="image-slot">
                        <span>-</span>
                      </div>
                    </template>
                  </el-image>
                </template>
                <img
                  :src="scope.row[v.field]"
                  style="height: 250px"
                  alt=""/>
              </el-popover>
            </template>
            <template v-else-if="v.field === 'advertisingStatus'">
              <el-switch v-model="scope.row.advertisingStatus" active-color="#13ce66" :active-value="1" :inactive-value="0"
                         @change="setWebCpsLiveAdStatus(scope.row)" />
            </template>
            <template v-else-if="v.field === 'detailUrl' || v.field === 'dyDeeplink' || v.field === 'authorOpenid'">
              <div class="tab-editor">
                <el-tooltip effect="dark" :content="scope.row[v.field]" placement="top-start">
                  <div style="max-width: 500px;">
                    <span @click="handleCopy" >{{ scope.row[v.field] }}</span>
                  </div>
                </el-tooltip>
              </div>
            </template>
            <template v-else-if="v.field === 'inStock' || v.field === 'isKolProduct'">
              <span>{{ scope.row[v.field] ? "有" : "无" }} </span>
            </template>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="200">
          <template v-slot="scope" align="center">
            <el-button @click="update(scope.row)" type="success" size="mini">编辑</el-button>
            <el-button @click="toPage(scope.row)" type="primary" size="mini">链接信息</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 20]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;"/>
    </div>
    <el-dialog title="主播配置" v-model="dialogVisible" width="35%">
      <el-form :model="form" style="margin-right: 20px;margin-left: 20px">
        <el-form-item label="主播描述" >
          <el-input v-model="form.authorName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="投放单价" >
          <el-input v-model="form.advertisingPrice" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="主播主图" prop="authorPic">
          <el-upload
            class="avatar-uploader"
            :action="$baseURL + 'common/upload/image'"
            :headers="header"
            :show-file-list="false"
            :on-success="onSuccess"
            accept="image/*"
          >
            <img
              v-if="form.authorPic"
              :src="form.authorPic"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="setWebCpsLive">
          保存
        </el-button>
      </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import initTableMixin from '@/mixins/initTable'
import { mapGetters } from 'vuex'
import { setWebCpsLive, setWebCpsLiveAdStatus } from '@/api/manage/cps/live'
export default {
  name: 'liveCommodity',
  components: {
  },
  mixins: [initTableMixin],
  data () {
    return {
      commodityColumns: [
        { field: 'authorOpenid', title: '主播openid' },
        { field: 'authorName', title: '主播描述' },
        { field: 'productCategory', title: '商品类别' },
        { field: 'authorPic', title: '主图' },
        { field: 'dyDeeplink', title: '唤起链接' },
        { field: 'averageGmv', title: '场均gmv' },
        { field: 'fansNum', title: '粉丝数量' },
        { field: 'averageCommissionRate', title: '主播平均佣金率' },
        { field: 'gender', title: '面向人群' },
        { field: 'onlineNum', title: '在线人数' },
        { field: 'startTime', title: '开播时间' },
        { field: 'activeStatus', title: '活动状态' },
        { field: 'advertisingPrice', title: '投放单价' }
      ],
      activityOptions: [
        { activityId: 0, title: '未活动' },
        { activityId: 1, title: '活动' }
      ],
      placeStatusOptions: [
        { statusId: 0, title: '未投放' },
        { statusId: 1, title: '投放' }
      ],
      dialogVisible: false,
      header: {},
      form: {}
    }
  },
  created () {
    this.header = {
      Authorization: 'Bearer ' + this.access_token
    }
    this.init()
  },
  computed: {
    ...mapGetters([
      'access_token'
    ])
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/webCpsLive/list'
      return true
    },
    sizeChange (e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange (e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    toQuery () {
      this.init()
    },
    changeCpsApp (item) {
      this.tableParams.appId = item
    },
    update (row) {
      this.form.id = row.id
      this.form.authorPic = row.authorPic
      this.form.authorName = row.authorName
      this.form.advertisingPrice = row.advertisingPrice
      this.dialogVisible = true
    },
    onSuccess (res) {
      if (res.code === 200) {
        this.form.authorPic = 'http://static.timewit.cn/' + res.data[0] || ''
      }
    },
    toPage (e) {
      this.$router.push({
        path: '/cps/place/config',
        query: { id: e.id, oid: e.authorOpenid, linkid: e.authorOpenid, title: e.authorName, img: e.authorPic, type: 'live' }
      })
    },
    setWebCpsLive () {
      setWebCpsLive(this.form)
      this.dialogVisible = false
      this.init()
    },
    setWebCpsLiveAdStatus (item) {
      setWebCpsLiveAdStatus({ id: item.id, advertisingStatus: item.advertisingStatus })
    },
    // 点击复制
    handleCopy (e) {
      const text = e.target.innerText
      const input = document.createElement('input')

      input.setAttribute('id', 'copyInput')
      input.setAttribute('value', text)
      document.getElementsByTagName('body')[0].appendChild(input)
      document.getElementById('copyInput').select()
      if (document.execCommand('copy')) {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      } else {
        this.$message({
          type: 'error',
          message: '浏览器不支持复制功能'
        })
      }
      document.getElementById('copyInput').remove()
    }
  }
}
</script>

<style scoped>
.search-wrapper {
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 30px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.search-row {
  & > .el-select,
  & > .el-input {
    margin-right: 30px;
    width: 220px;
  }
}

.el-tabs__content {
  padding: 0;
}
.el-pagination {
  text-align: right;
}

.tab-editor {
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .el-upload:hover {
  border-color:red;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 200px;
  height: 150px;
  display: block;
}
</style>
